import { connect } from 'react-redux'
import requestAddLabel from '../../sagas/requestAddLabel'
import requestRemoveLabel from '../../sagas/requestRemoveLabel'
import labelsSelector from './labelsSelector'
import Labels from './Labels'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  labelsSelector,
  {
    requestAddLabel,
    requestRemoveLabel
  }
)(Labels))
